import * as React from "react";
import { withRouter, RouteComponentProps, Switch, Route, Redirect } from "react-router";
import { SideBar, SideBarTabConfig, resolveCurrentUrl, UserContextConsumer, BPMUser } from 'bpm-web-generic';
import DownloadHistory from "src/pages/DownloadHistory";
import { Environment } from "src/env";
import { BPMRedirect } from "src/components/BPMRedirect";

class InnerAccount extends React.Component<RouteComponentProps<{ page: string, subPage: string }>> {

    private getPages(user: BPMUser): SideBarTabConfig[] {
        return [{
            title: 'My Account',
            path: 'my-account',
            component: () => <BPMRedirect to={`${Environment.NEW_POOL_URL}/d/account/overview`} />
        },
        {
            title: 'Change Password',
            path: 'change-password',
            component: () => <BPMRedirect to={`${Environment.NEW_POOL_URL}/d/account/overview`} />
        },
        {
            title: 'Profile Picture',
            path: 'profile-picture',
            component: () => <BPMRedirect to={`${Environment.NEW_POOL_URL}/d/account/overview`} />
        }, {
            title: 'Payment History',
            path: 'payment-history',
            component: () => <BPMRedirect to={`${Environment.NEW_POOL_URL}/d/account/payment`} />
        }, {
            title: 'Membership Info',
            path: 'membership-info',
            component: () => <BPMRedirect to={`${Environment.NEW_POOL_URL}/d/account/plan`} />
        }, {
            title: 'Manage Subscription',
            path: 'subscription',
            component: () => <BPMRedirect to={`${Environment.NEW_POOL_URL}/d/account/plan`} />
        }, {
            title: 'Download History',
            path: 'download-history',
            component: DownloadHistory
        }].filter(Boolean) as SideBarTabConfig[]
    }

    onScroll() {
        if (document.getElementsByClassName('bpm-promo-banner').length && document.scrollingElement!.scrollTop <= 60) {
            const sideBar = document.getElementsByClassName('navbar-expand-bpm-brk-4')
            if (sideBar.length && sideBar[0].clientHeight > 200) { // < 200 is mobile menu
                (sideBar[0] as HTMLDivElement).style.marginTop = (60 - document.scrollingElement!.scrollTop) + 'px'
            }
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    public render() {
        return <UserContextConsumer>{(user) => {
            return <div className="account">
                <SideBar pages={this.getPages(user!)} subPage={this.props.match.params.subPage} />
                <div className="sidebar-right-content">
                    <Switch>
                        {this.getPages(user).map(page => {
                            return <Route path={'/' + resolveCurrentUrl(this.props.match.params.page, page.path!)} key={page.path} component={page.component} />
                        })}
                        <Route>
                            <Redirect to={'/' + resolveCurrentUrl(this.props.match.params.page, this.getPages(user)[0].path!)} />
                        </Route>
                    </Switch>
                </div>
            </div>
        }}</UserContextConsumer>

    }
}
const Acc = withRouter(InnerAccount)

export default class Account extends React.Component {
    public render() {
        return <Route path={'/:page/:subPage?'} component={Acc} />
    }
}


// WEBPACK FOOTER //
// ./src/layout/Account.tsx